let routes = [{
  path: '/',
  component: (resolve) => require(['./page/index/index'], resolve),
},{
  path: '/RegQuery',
  component: (resolve) => require(['./page/RegQuery/RegQuery'], resolve),
},{
  path: '/About',
  component: (resolve) => require(['./page/about/about'], resolve),
},{
  path: '/Education',
  component: (resolve) => require(['./page/education/education'], resolve),
},{
  path: '/education/detail',
  component: (resolve) => require(['./page/education/EducationDetail'], resolve),
},{
  path: '/ApplyReg',
  component: (resolve) => require(['./page/applyReg/applyReg'], resolve),
},{
  path: '/InfoState',
  component: (resolve) => require(['./page/InfoState/InfoState'], resolve),
},{
  path: '/Profession',
  component: (resolve) => require(['./page/profession/Profession'], resolve),
},{
  path: '/Login',
  component: (resolve) => require(['./page/login/login'], resolve),
},{
  path: '/Reg',
  component: (resolve) => require(['./page/login/reg'], resolve),
},{
  path: '/Retrieve',
  component: (resolve) => require(['./page/login/retrieve'], resolve),
},{
  path: '/UserInfo',
  component: (resolve) => require(['./page/user/index'], resolve),
},{
  path: '/Publicity',
  component: (resolve) => require(['./page/publicity/Publicity'], resolve),
},{
  path: '/InfoDetail',
  component: (resolve) => require(['./page/education/InfoDetail'], resolve),
},{
  path: '/wenjian',
  component: (resolve) => require(['./page/education/InfoDetail'], resolve),
},{
  path: '/infoPublicity',
  component: (resolve) => require(['./page/publicity/infoPublicity'], resolve),
},{
  path: '/projectReview',
  component: (resolve) => require(['./page/projectReview/index'], resolve),
},{
  path: '/project/detail',
  component: (resolve) => require(['./page/project/ProjectDetail'], resolve),
},{
  path: '/updateRegistration',
  component: (resolve) => require(['./page/updateRegistration/index'], resolve),
},{
  path: '/updateRegistrationRecord',
  component: (resolve) => require(['./page/updateRegistrationRecord/index'], resolve),
},{
  path: '/NoticeList',
  component: (resolve) => require(['./page/NoticeList/index'], resolve),
},{
  path: '/NewsList',
  component: (resolve) => require(['./page/NewsList/index'], resolve),
}];

export default routes;